module.exports = __webpack_public_path__ + "img/fodown_one_1.10ce76d4.png";